import diService from "../domains/di/application/di.service";
import { TsyringeDiDecorator } from "../domains/di/infrastructure/tsyringe";
import type { Tokens } from "./di";

export const diDecorator = diService.createDecoratorInstance<Tokens>(TsyringeDiDecorator);
